function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(43.921569%,43.921569%,43.921569%)",
      fillOpacity: 1
    },
    d: "M 34.699219 36.800781 L 13.300781 36.800781 C 6.300781 36.800781 0.5 31.101562 0.5 24 C 0.5 16.898438 6.300781 11.199219 13.300781 11.199219 L 34.601562 11.199219 C 41.699219 11.199219 47.398438 17 47.398438 24 C 47.5 31.101562 41.699219 36.800781 34.699219 36.800781 Z M 13.300781 12.199219 C 6.800781 12.199219 1.5 17.5 1.5 24 C 1.5 30.5 6.800781 35.800781 13.300781 35.800781 L 34.601562 35.800781 C 41.101562 35.800781 46.398438 30.5 46.398438 24 C 46.398438 17.5 41.101562 12.199219 34.601562 12.199219 Z M 13.300781 12.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 45.398438 24 C 45.398438 29.910156 40.609375 34.699219 34.699219 34.699219 C 28.789062 34.699219 24 29.910156 24 24 C 24 18.089844 28.789062 13.300781 34.699219 13.300781 C 40.609375 13.300781 45.398438 18.089844 45.398438 24 Z M 45.398438 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 34.699219 34.601562 C 28.800781 34.601562 24.101562 29.800781 24.101562 24 C 24.101562 18.199219 28.898438 13.398438 34.699219 13.398438 C 40.5 13.398438 45.300781 18.199219 45.300781 24 C 45.300781 29.800781 40.5 34.601562 34.699219 34.601562 Z M 34.699219 14.398438 C 29.398438 14.398438 25.101562 18.699219 25.101562 24 C 25.101562 29.300781 29.398438 33.601562 34.699219 33.601562 C 40 33.601562 44.300781 29.300781 44.300781 24 C 44.300781 18.699219 40 14.398438 34.699219 14.398438 Z M 34.699219 14.398438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleon);
export default __webpack_public_path__ + "static/media/Toggle on.310f66d1e7277dbcb3f73325f3d3aa4d.svg";
export { ForwardRef as ReactComponent };